import React from 'react'
import { CommonPublisherLinkButtonEntityOrSubEntity } from 'src/publisher/shared/components/button/common-publisher-link-button-entity-or-sub-entity'
import { WebsiteLinkActionButtonEntityInterface } from 'src/shared/entities/button/website-link.action-button.schema'

// intentionally repeats open url button
const TEST_ID = 'open-url-button'

export interface WebsiteLinkButtonProps {
  entity: WebsiteLinkActionButtonEntityInterface
}

export const WebsiteLinkButton = ({ entity }: WebsiteLinkButtonProps) => {
  return (
    <CommonPublisherLinkButtonEntityOrSubEntity
      entity={entity}
      dataTestId={TEST_ID}
      href={entity.websiteLink}
      rel={entity.rel}
      target={entity.linkTarget}
    />
  )
}
